import { render, staticRenderFns } from "./RealEstateDataSourcesListCard.vue?vue&type=template&id=d2346996"
import script from "./RealEstateDataSourcesListCard.vue?vue&type=script&lang=ts"
export * from "./RealEstateDataSourcesListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports